import styles from './InviteConsumerModal.module.scss';
import { DefaultOpenModalProps } from 'components/button/OpenModalButton/OpenModalButton';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { activateSnackbar } from 'store/features/ui';
import { FormModal } from 'components/form/FormModal/FormModal';
import { InviteConsumerForm } from './InviteConsumerForm';
import { inviteConsumerAppUser } from 'lib/firebase';

export interface InviteConsumerModalProps extends DefaultOpenModalProps {
    onConsumerInvited: React.Dispatch<React.SetStateAction<boolean>>;
    supplierId: string;
}

export interface InviteConsumerData {
    email: string;
    deviceId: string;
}

/** Form to invite app user consumers (i.e., homeowner end user etc) to the app. */
export const InviteConsumerModal = ({
    modalOpen,
    setModalOpen,
    onConsumerInvited,
    supplierId,
}: InviteConsumerModalProps) => {
    const dispatch = useDispatch();

    const inviteConsumerSchema = yup.object({
        email: yup.string().email().required(),
        device: yup.string(),
    });

    const defaultValues: InviteConsumerData = {
        email: '',
        deviceId: '',
    };

    const onError = () => {
        dispatch(
            activateSnackbar({
                message: 'There was a problem inviting this consumer.',
                severity: 'error',
            })
        );
    };

    const onSubmit = (data: InviteConsumerData) => {
        // Make network call to send the invite to the user
        inviteConsumerAppUser(supplierId, data.deviceId, data.email).then(
            () => {
                // Call the onConsumerInvited callback to refresh the Consumers table.
                onConsumerInvited(true);
                dispatch(
                    activateSnackbar({
                        message: 'Invite successfully sent to consumer.',
                        severity: 'success',
                    })
                );
            }
        );
    };

    return (
        <div
            data-testid="InviteConsumerModal"
            className={styles.InviteConsumerModal}
        >
            <FormModal
                defaultValues={defaultValues}
                validationSchema={inviteConsumerSchema}
                title={'Invite a user to the app'}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                onErrorHandler={onError}
                onValidHandler={onSubmit}
            >
                <InviteConsumerForm supplierId={supplierId} />
            </FormModal>
        </div>
    );
};
